// extracted by mini-css-extract-plugin
export default {"profileInfoHeader":"UserInfoHeader_profileInfoHeader__sq3z8","userInfo":"UserInfoHeader_userInfo__uWI3f","column":"UserInfoHeader_column__+WKSY","row":"UserInfoHeader_row__MZzVp"};